import type { Route } from 'fitify-ui-onboarding/src/types/routeTypes'

import { ALL_PAGES } from 'data/routes'
import type { Funnel } from 'types/state'

/**
 * Gets the current and the next routes based on the current path.
 * Include all possible routes, iteration stops at the first non-conditional route,
 * to be able to preload images for all possible next routes.
 */
export const getPrefetchRoutes = (
  pagesCache: Route<string>[],
  currentPath: string
): Route<string>[] => {
  if (!pagesCache.length) {
    return []
  }

  const currentPageIndex = pagesCache.findIndex(
    (route) => route.path === currentPath
  )

  if (currentPageIndex >= 0) {
    const routes: Route<string>[] = []

    for (const route of pagesCache.slice(currentPageIndex)) {
      const isFirstPage = routes.length === 0

      routes.push(route)
      const isConditionalPage = Boolean(route.condition)

      // Always include first page, to be able to preload its images, when waiting for onboarding initialization
      // Break if not first page and not conditional
      if (!isFirstPage && !isConditionalPage) {
        break
      }
    }

    return routes
  }

  return []
}

/**
 * Gets the route key based on the route path and funnel.
 */
export const getRouteKey = (
  route: Route<string>,
  funnel: Funnel
): string | undefined => {
  return Object.entries(ALL_PAGES[funnel]).find(
    ([_, page]) => page.path === route.path
  )?.[0]
}
